// import { Tune } from "@mui/icons-material";
import {
  Divider,
  Tooltip,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined.js";

export default function SelectTrainCycle({
  thirdTrainOption,
  setThirdTrainOption,
  time,
  setTime,
  selectTrainType,
  selectDatasetType,
}) {
  const [cycleType, setCycleType] = useState("monthly" || time.period); // 월/주 선택
  const [weekNumber, setWeekNumber] = useState(1); // 몇째주
  const [dayOfWeek, setDayOfWeek] = useState(1 || time.week); // 요일
  const [hour, setHour] = useState("00"); // 시간
  const [minute, setMinute] = useState("00"); // 분

  const weekNumbers = [1, 2, 3, 4, 5];
  const daysOfWeek = [
    { value: 0, label: "일요일" },
    { value: 1, label: "월요일" },
    { value: 2, label: "화요일" },
    { value: 3, label: "수요일" },
    { value: 4, label: "목요일" },
    { value: 5, label: "금요일" },
    { value: 6, label: "토요일" },
  ];

  const weekdayNames = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  useEffect(() => {
    setTime((prev) => ({
      ...prev,
      period: cycleType === "monthly" ? "monthly" : "weekly",
      week: cycleType === "monthly" ? weekNumber.toString() : "1",
      weekday: weekdayNames[dayOfWeek],
      exe: `${hour}:${minute}`,
    }));
  }, [cycleType, weekNumber, dayOfWeek, hour, minute]);

  // useEffect(() => {
  //   if (selectTrainType === "continue") {
  //     setThirdTrainOption(false);
  //   }
  // }, [selectTrainType]);

  // useEffect(() => {
  //   if (selectDatasetType === "db") {
  //     setThirdTrainOption(false);
  //   }
  // }, [selectDatasetType]);

  const handleCheckTrainCycle = () => {
    setThirdTrainOption(!thirdTrainOption);
  };

  // 각 핸들러 함수 수정
  const handleCycleTypeChange = (e) => {
    setCycleType(e.target.value);
  };

  const handleWeekNumberChange = (e) => {
    setWeekNumber(e.target.value);
  };

  const handleDayOfWeekChange = (e) => {
    setDayOfWeek(e.target.value);
  };

  const handleTimeChange = (e) => {
    const [h, m] = e.target.value.split(":");
    setHour(h);
    setMinute(m);
  };

  return (
    <>
      <Divider>{t("Condition")}</Divider>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <span>{t("TrainCondition")}</span>
        <Tooltip title="과검률, 미검률은 추후 update 예정입니다">
          {/* <InfoOutlinedIcon sx={{ fontSize: "20px", marginLeft: "3px" }} /> */}
        </Tooltip>
      </div>
      <div className="check-train-option">
        <input
          type="checkbox"
          id="horns"
          name="threshold"
          checked={false}
          disabled
        />
        <span>과검률</span>
      </div>
      <div className="check-train-option">
        <input
          type="checkbox"
          id="horns"
          name="threshold"
          checked={false}
          disabled
        />
        <span>미검률</span>
      </div>
      <div className="check-train-option">
        <input
          type="checkbox"
          id="train-cycle"
          checked={thirdTrainOption}
          onChange={handleCheckTrainCycle}
          // disabled={
          //   selectTrainType === "continue" || selectDatasetType === "db"
          // }
        />
        <span>학습 반복주기</span>
      </div>
      {thirdTrainOption && (
        <div
          className="cycle-settings"
          style={{ marginLeft: "20px", marginTop: "10px" }}
        >
          <FormControl size="small" sx={{ minWidth: 120, marginRight: 1 }}>
            <InputLabel>주기</InputLabel>
            <Select
              value={cycleType}
              onChange={handleCycleTypeChange}
              label="주기"
            >
              <MenuItem value="monthly">월</MenuItem>
              <MenuItem value="weekly">주</MenuItem>
            </Select>
          </FormControl>

          {cycleType === "monthly" && (
            <FormControl size="small" sx={{ minWidth: 120, marginRight: 1 }}>
              <InputLabel>째주</InputLabel>
              <Select
                value={weekNumber}
                onChange={handleWeekNumberChange}
                label="째주"
              >
                {weekNumbers.map((num) => (
                  <MenuItem key={num} value={num}>
                    {num}째주
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <FormControl size="small" sx={{ minWidth: 120, marginRight: 1 }}>
            <InputLabel>요일</InputLabel>
            <Select
              value={dayOfWeek}
              onChange={handleDayOfWeekChange}
              label="요일"
            >
              {daysOfWeek.map((day) => (
                <MenuItem key={day.value} value={day.value}>
                  {day.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            size="small"
            type="time"
            value={`${hour}:${minute}`}
            onChange={handleTimeChange}
            sx={{ width: 150 }}
          />
        </div>
      )}
    </>
  );
}
